export default __webpack_public_path__ + "static/media/groups.94e9c1f5.svg";